import {CreateDialog, CreateDialogProps} from '@/components/refinedev/dialogs/create-dialog';
import useDialogState from '@/hooks/useDialogState';
import {Button} from '@/shadcn_components/ui/button';
import {useCan, UseCanProps} from '@refinedev/core';
import {PlusCircleIcon} from 'lucide-react';

export type CreateDialogButtonProps = {
  onSuccess?: (data) => void;
  canParams?: UseCanProps['params'];
} & Partial<CreateDialogProps>;

export const CreateDialogButton = (props: CreateDialogButtonProps) => {
  const {onSuccess, ...rest} = props;
  const dialogState = useDialogState();
  const {resource} = props;

  const {data: canAccess} = useCan({
    resource,
    action: 'create',
    params: props.canParams,
  });
  if (canAccess?.can === false) return null;

  return (
    <>
      <Button variant="default" type="button" size="sm" onClick={dialogState.openDialog}>
        <PlusCircleIcon className="size-4" />
        Tạo mới
      </Button>
      {dialogState.open && (
        <CreateDialog
          dialogState={dialogState}
          {...rest}
          formProps={{
            ...rest.formProps,
            refineCoreProps: {
              onMutationSuccess: onSuccess,
              redirect: false,
              ...rest.formProps?.refineCoreProps,
            },
          }}
        />
      )}
    </>
  );
};
